<template>
  <v-container fluid class="campaigns-overview">
    <v-layout row wrap>
      <v-flex xs8>
        <overall-campaigns-pie-chart v-if="this.overallData.accumulatedMsgsStatus" :overall-data="overallData.accumulatedMsgsStatus"/>
      </v-flex>
      <v-flex xs4>
        <campaigns-numbers v-if="this.overallData.accumulatedMsgsStatus" :overall-data="overallData"/>
      </v-flex>
      <v-flex xs12>
        <campaigns-bar-chart v-if="this.overallData.accumulatedMsgsStatus" :overall-data="overallData" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import overallCampaignsPieChart from "./overallCampaignsPieChart";
  import campaignsNumbers from "./campaignsNumbers";
  import campaignsBarChart from "./campaignsBarChart";
  export default {
    name: "index",
    components: {
      overallCampaignsPieChart,
      campaignsNumbers,
      campaignsBarChart,
    },
    data() {
      return {
        overallData: {}
      }
    },
    mounted() {
      this.getInsights()
    },
    methods: {
      getInsights() {
        this.$http_chat.get(`/campaigns/overall-analytics/?bot_id=${this.$store.state.bot.botId}`)
        .then(res=>{
          const overallData = res.data.data
          if(!overallData) {
            conso
            this.$emit('error')
          } else {
            this.overallData = overallData
          }
        })
        .catch(err=>{
          this.$emit('error')
        })
      }
    }
  }
</script>

<style scoped>

</style>
